export const business = {
  name: "Perth Home Air Conditioning",
  phoneDisplay: "(08) 9228 3555",
  phoneHref: "tel:+61892283555",
  serviceArea: "Perth metropolitan area, Western Australia",
  url: "https://perthhomeairconditioning.com.au/",
};
